export default __webpack_public_path__ + "static/media/edit.fa94a6bc.svg";